import React from 'react';

import { Alert } from 'antd';
import { useIntl } from 'react-intl';

import type { ExecutionsHistoryWarnings } from '@src/models/interfaces/executionsHistoryDashboard.interface';

import { getWarningMessages } from './warningMessages';

interface HistoryWarningsProps {
  warnings?: ExecutionsHistoryWarnings;
}

/** Explains the orders the report counted differently or left out, when there are any. */
const HistoryWarnings: React.FC<HistoryWarningsProps> = ({ warnings }) => {
  const intl = useIntl();
  const messages = getWarningMessages(intl, warnings);

  if (!messages.length) return null;

  return (
    <Alert
      type="info"
      showIcon
      message={messages.length === 1 ? messages[0] : (
        <ul>
          {messages.map(message => <li key={message}>{message}</li>)}
        </ul>
      )}
    />
  );
};

export default HistoryWarnings;
